import { registerShape } from './registry';
import { squareShape } from './square';
import { hexagonShape } from './hexagon';
import { triangleShape } from './triangle';
import { rhombusShape } from './rhombus';

/**
 * Registration of the built-in shapes.
 *
 * Phase 1 shipped the square; Phase 2 adds the hexagon, triangle and rhombus.
 * None of them needed a tessellator of their own — the convex-fan fallback
 * handles any convex footprint — and only the triangle needed anything beyond
 * an outline and a layout, because it is the one that has to alternate
 * orientation in order to tile.
 */

let registered = false;

export function registerBuiltinShapes(): void {
  if (registered) return;
  registered = true;

  registerShape(squareShape);
  registerShape(hexagonShape);
  registerShape(triangleShape);
  registerShape(rhombusShape);
}

export * from './registry';
export * from './tessellate';
export { squareShape } from './square';
export { hexagonShape } from './hexagon';
export { triangleShape } from './triangle';
export { rhombusShape } from './rhombus';
